import React from 'react';
import { DVITemplateManager } from '../../components/DVI';

const DVITemplatesPage: React.FC = () => <DVITemplateManager />;
export default DVITemplatesPage;
